import {
  GET_CRM_DATA,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
} from "../../shared/constants/ActionTypes";
import jwtAxios from "@crema/services/auth/jwt-auth/jwt-api";

export const onGetCrmData = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .get("/dashboard/all-basic-dashboardCount")
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_CRM_DATA,
            payload: data.data.data,
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};
